export default "__VITE_ASSET__DgHipaIC__"